import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  useRouter,
} from 'vue-router';
import {
  useStore,
} from '@/store';

export interface IHeaderTextLink {
  name: string;
  route?: string;
  url?: string;
  event?: string;
  userOnly?: boolean;
  hidden?: boolean;
  isMobile?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderTextLinkButton',
  props: {
  name: {
    type: String,
    required: true,
  },
  route: {
    type: String,
    required: false,
    default: '',
  },
  url: {
    type: String,
    required: false,
    default: '',
  },
  block: {
    type: Boolean,
    required: false,
  },
  event: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const navStore = useStore.nav;



const router = useRouter();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    class: _normalizeClass(["rounded-lg p-3 text-left text-base font-normal no-underline hover:no-underline active:no-underline", {
      'bg-base-300 font-bold': __props.name === _unref(router).currentRoute.value.name,
      'hover:bg-blue-primary hover:text-white': _unref(navStore).isLightTheme,
      'hover:bg-gray-100 hover:text-black': !_unref(navStore).isLightTheme,
    }]),
    target: __props.url ? '_blank' : undefined,
    rel: "noopener noreferrer",
    href: __props.url,
    to: __props.route,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(__props.event || 'click')))
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.name), 1)
    ]),
    _: 1
  }, 8, ["class", "target", "href", "to"]))
}
}

})